module.exports = __webpack_public_path__ + "img/expovina_02(1).80fb42ef.jpg";